import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";

function Home() {

    const videoRef = useRef<any>(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = true;
            videoRef.current.defaultMuted = true;
            videoRef.current.setAttribute("muted", "")
            videoRef.current.load();
        }
    }, []);

    return <>
        <main className="home">
            <video autoPlay muted loop disablePictureInPicture disableRemotePlayback playsInline ref={videoRef}>
                <source src={process.env.PUBLIC_URL + "/videos/001.webm"} type="video/webm" />
            </video>
            <img className="claim" src={process.env.PUBLIC_URL + "/images/claim.webp"} alt="MAKE IT VISIBLE." />
        </main>
        <div className="cta-home content-box">
            <NavLink to="/kontakt" className="button">Jetzt Projekt anfragen!</NavLink>
            <span>&copy; {(new Date()).getFullYear()} Simon Adler</span>
        </div>
    </>
}

export default Home;